<div class="p-grid mt-2">
	<div class="p-col-12 p-lg-6 d-flex flex-column">
		<div>
			<span class="p-float-label">
				<p-dropdown
					id="ccProcessor"
					autoDisplayFirst="false"
					[(ngModel)]="venueService.ooVenue.ccProcessor"
					[options]="ccProcessors"
					[style]="{ width: '100%' }"
					(onChange)="changesToSave = true; validateProcessor()"
				>
				</p-dropdown>
				<label for="ccProcessor">Credt Card Processor</label>
			</span>
		</div>
		<ng-container *ngIf="venueService.ooVenue.ccProcessor !== 5">
			<div class="mt-4">
				<span class="p-float-label">
					<input
						pInputText
						class="w-100"
						id="ccProcessorApiKey"
						type="text"
						[(ngModel)]="venueService.ooVenue.ccProcessorApiKey"
						(ngModelChange)="changesToSave = true"
						[disabled]="venueService.ooVenue.ccProcessor === 4"
					/>
					<label for="ccProcessorApiKey">
						<span *ngIf="venueService.ooVenue.ccProcessor === 1">Shift4 Auth Token</span>
						<span *ngIf="venueService.ooVenue.ccProcessor === 2">API Login ID</span>
					</label>
				</span>
			</div>
			<div class="mt-4 mb-2">
				<span class="p-float-label">
					<input
						pInputText
						class="w-100"
						id="ccProcessorApiSecret"
						type="text"
						[(ngModel)]="venueService.ooVenue.ccProcessorApiSecret"
						(ngModelChange)="changesToSave = true"
						[disabled]="venueService.ooVenue.ccProcessor === 4"
					/>
					<label for="ccProcessorApiSecret">
						<span *ngIf="venueService.ooVenue.ccProcessor === 1">Shift4 Access Token</span>
						<span *ngIf="venueService.ooVenue.ccProcessor === 2">API Transaction Key</span>
						<span *ngIf="venueService.ooVenue.ccProcessor === 4">FocusPay Merchant ID</span>
					</label>
				</span>
			</div>
		</ng-container>
	</div>
	<div class="p-col-12 p-lg-6 d-flex flex-column">
		<div>
			<span class="p-float-label">
				<p-dropdown
					autoDisplayFirst="false"
					[options]="cardSecurityOptions"
					id="ccCardSecurityRule"
					[autoDisplayFirst]="false"
					[baseZIndex]="10000"
					appendTo="body"
					[(ngModel)]="venueService.ooVenue.ccCardSecurityRule"
					[style]="{ width: '100%' }"
					(onChange)="changesToSave = true; changesToSaveChange.emit(true)"
				>
				</p-dropdown>
				<label for="ccCardSecurityRule">Card Security Rule</label>
			</span>
		</div>
	</div>
</div>

<ng-container *ngIf="venueService.ooVenue.ccProcessor === 5">
	<app-payment-processor-focuspay-datacap
		(changesToSaveChange)="onVenueChanges($event)"
		[ccProcessors]="ccProcessors"
	></app-payment-processor-focuspay-datacap>
</ng-container>
